import type { Localizations, LocalizationsProvider } from "~/service/l10n";
import { theme_ns } from "./theme";

export const translations = {
  'en-US': {
    // Common terms
    'common.today': 'Today',
    'common.learn-more': 'Learn more',
    'common.lunch-list': 'Lunch list',
    'common.floor': 'Floor',
    'common.closed': 'Closed',
    'common.search': 'Search',
    'common.stores': 'Stores',
    'common.offers': 'Offers',
    'common.events': 'Events',
    'common.store': 'Store',
    'common.store-name': 'Store',
    'common.category': 'Category',
    'common.see-all': 'See all',
    'common.see-more': 'See more',
    'common.see-less': 'See less',
    'common.clear-selection': 'Clear selection',
    'common.clear.search': 'Clear search',
    'common.opening-hours': 'Opening hours',
    'common.valid': 'Valid',
    'common.no-results': 'No results found',
    'common.no-content': 'No content currently available',
    'common.follow-instagram': 'Follow us on instagram',
    'common.no-opening-hours': 'No opening hours currently available',
    'common.no-content-available': 'No content currently available',
    
    // Weekdays should be common
    'common.weekdays.monday': 'Monday',
    'common.weekdays.tuesday': 'Tuesday',
    'common.weekdays.wednesday': 'Wednesday',
    'common.weekdays.thursday': 'Thursday',
    'common.weekdays.friday': 'Friday',
    'common.weekdays.saturday': 'Saturday',
    'common.weekdays.sunday': 'Sunday',
    'common.exceptional-hours': 'Exceptional opening hours',
    'common.mon-fri': 'Mon-Fri',
    'common.sat': 'Sat',
    'common.sun': 'Sun',

    'opening-hours-swiper.todays-hours': "Today's hours",
    'opening-hours-swiper.tomorrows-hours': "Tomorrow's hours",
    'opening-hours-swiper.day-after-hours': "Day after tomorrow's hours",
    'opening-hours-swiper.store-hours-vary': 'See individual stores opening hours',
    
    'footer.connect': 'connect',
    'footer.all-hours': 'see all hours',
    'footer.visit-us': 'visit us',
    'footer.privacy-center': 'Privacy center',
    
    'search.no-results': 'Your search did not match any results',
    'search.results': 'Search results',
    'search.opening-hours-not-available': 'Opening hours not available',
    'search.view-store': 'View store',
    'search.call-store': 'Call us',
    'search.floor-1': '1st floor',
    'search.floor-2': '2nd floor',
    'search.floor-3': '3rd floor',
    'search.floor-4': '4th floor',
    'search.floor-5': '5th floor',
    'search.store-section-header': 'Stores',
    'search.offer-section-header': 'Offers',
    'search.event-section-header': 'Events',
    'search.results-for': 'Results for',
    
    'stores.all-categories': 'All categories',
    'stores.no-results': 'No stores found',
    
    'store.see-on-map': 'See on the map',
    'store.exceptions': 'Exceptions',
    'store.all-offers': 'See all',
    'store.related': 'Related stores',
    'store.all-related': 'See all related stores',
    'store.status.CLOSED': 'Closed',
    'store.status.TEMPORARY_CLOSED': 'Temporary closed',
    'store.status.OPEN': 'Open',
    'store.status.BY_APPOINTMENT': 'By appointment',

    'lunch-list.modal-title': 'Lunch list',
    'about-us.opening-hours-note': 'For specific hours of operation at your favorite shopping and dining destinations:',
    'about-us.opening-hours-goto-stores': 'Go to stores',
    'about-us.opening-hours-center-doors-open': 'Center doors open',
    'about-us.parking-title': 'Parking',
    'about-us.sustainability-title': 'Sustainability',
    'about-us.contact-us-title': 'Contact us',
    'about-us.opening-hours-exceptional': 'Exceptional opening hours',

    // For campaign pages:
    'offers.allDays': 'All days',
    'offers.allCategories': 'All categories',
    'offers.allOffers': 'All offers',
    'offers.showWishList': 'Show wish list',
    'offers.closeOffer': 'Close',
    'offers.seeWholeOffer': 'See whole offer',
    'offers.noOffers': 'Unfortunately no offers are currently available',
    'offers.openInfo':'Open offer description',
    'offers.daysLowestPrice': '30 day lowest price',
    'offers.send-email': 'Send email',

    'news-and-events.news-and-events': 'News and events ',
    
    'offer-lists.search-filter-store-name': 'Store',
    'offer-lists.valid-from': 'Valid from',

    'news-and-events-lists.search-filter-keyword': 'Keyword',

    'news-and-events-single-article.read.more': 'Read more news & events',

    'news-letter-lift.email-address': 'Enter your email address here',
    'news-letter-lift.subscribe': 'Subscribe',
    'news-letter-lift.confirmation-message': 'You have successfully subscribed to the newsletter!',

    'feedback.required_fields_marked_by_star': 'Required fields',
    'feedback.target': 'Target',
    'feedback.choose_shop' : 'Choose a shop',
    'feedback.type_of_feedback' : 'Type of feedback',
    'feedback.message': 'Feedback',
    'feedback.name' : 'Name',
    'feedback.email' : 'Email',
    'feedback.target.general': 'General feedback',
    'feedback.target.store': 'Feedback to a specific company',
    'feedback.type.thanks': 'Thanks',
    'feedback.type.suggestion': 'Suggestion',
    'feedback.type.complaint': 'Complaint',
    'feedback.type.other': 'Other',
    'feedback.rsvp' : 'I would like to receive a reply',
    'feedback.privacy_statement' : 'Privacy policy',
    'feedback.thank_you' : 'Thank you for your feedback',
    'feedback.send': 'Send',
    'feedback.error.check_all_required_fields': 'Please check all required fields are filled',
    'feedback.error.field_required' : 'Field is required',
    'feedback.error.invalid_email_address' : 'Invalid email address',
    'feedback.error.please_choose_a_store' : 'Please choose a store',
  },
  'fi-FI': {
    // Common terms
    'common.today': 'Tänään',
    'common.learn-more': 'Lue lisää',
    'common.lunch-list': 'Lounaslista',
    'common.floor': 'Krs',
    'common.closed': 'Suljettu',
    'common.search': 'Haku',
    'common.stores': 'Liikkeet',
    'common.offers': 'Tarjoukset',
    'common.events': 'Tapahtumat',
    'common.store': 'Liike',
    'common.store-name': 'Liikkeet',
    'common.category': 'Kategoria',
    'common.see-all': 'Katso kaikki',
    'common.see-more': 'Näytä lisää',
    'common.see-less': 'Näytä vähemmän',
    'common.clear-selection': 'Tyhjennä valinta',
    'common.clear.search': 'Tyhjennä haku',
    'common.opening-hours': 'Aukioloajat',
    'common.valid': 'Voimassa',
    'common.no-results': 'Tuloksia ei löytynyt',
    'common.no-content': 'Ei näytettävää sisältöä juuri nyt',
    'common.follow-instagram': 'Seuraa meitä instagramissa',
    'common.no-opening-hours': 'Ei aukioloaikoja tällä hetkellä saatavilla',
    'common.no-content-available': 'Ei näytettävää sisältöä juuri nyt',
    
    // Weekdays should be common
    'common.weekdays.monday': 'ma',
    'common.weekdays.tuesday': 'ti',
    'common.weekdays.wednesday': 'ke',
    'common.weekdays.thursday': 'to',
    'common.weekdays.friday': 'pe',
    'common.weekdays.saturday': 'la',
    'common.weekdays.sunday': 'su',
    'common.exceptional-hours': 'Poikkeavat aukioloajat',
    'common.mon-fri': 'ma-pe',
    'common.sat': 'la',
    'common.sun': 'su',

    'opening-hours-swiper.todays-hours': 'Aukioloajat tänään',
    'opening-hours-swiper.tomorrows-hours': 'Aukioloajat huomenna',
    'opening-hours-swiper.day-after-hours': 'Aukioloajat ylihuomenna',
    'opening-hours-swiper.store-hours-vary': 'Katso yksittäisten liikkeiden aukioloajat',
    
    'footer.connect': 'Sosiaalinen media',
    'footer.all-hours': 'Katso aukioloajat',
    'footer.visit-us': 'Vieraile meillä',
    'footer.privacy-center': 'Tietosuojakäytäntö',
    
    'search.no-results': 'Hakusi ei tuottanut yhtään tulosta',
    'search.results': 'Hakutulokset',
    'search.opening-hours-not-available': 'Aukioloaikoja ei ole saatavilla',
    'search.view-store': 'Katso liikkeet',
    'search.call-store': 'Soita meille',
    'search.floor-1': '1. krs',
    'search.floor-2': '2. krs',
    'search.floor-3': '3. krs',
    'search.floor-4': '4. krs',
    'search.floor-5': '5. krs',
    'search.store-section-header': 'Liikkeet',
    'search.offer-section-header': 'Tarjoukset',
    'search.event-section-header': 'Tapahtumat',
    'search.results-for': 'Tulokset hakusanalle',
    
    'stores.all-categories': 'Kaikki kategoriat',
    'stores.no-results': 'Valitettavasti yhtään liikettä ei löytynyt',
    
    'store.see-on-map': 'Katso pohjakartalla',
    'store.exceptions': 'Poikkeavat aukioloajat',
    'store.all-offers': 'Kaikki tarjoukset',
    'store.related': 'Samanlaiset liikkeet',
    'store.all-related': 'Näytä kaikki liittyvät kaupat',
    'store.status.CLOSED': 'Suljettu',
    'store.status.TEMPORARY_CLOSED': 'Tilapäisesti suljettu',
    'store.status.OPEN': 'Auki',
    'store.status.BY_APPOINTMENT': 'Tilauksella',

    'about-us.opening-hours-note': 'Tietyt aukioloajat suosikkiostos- ja ruokailukohteissasi:',
    'about-us.opening-hours-goto-stores': 'Katso liikkeet ja palvelut',
    'about-us.opening-hours-center-doors-open': 'Kauppakeskuksen ovet auki',
    'about-us.parking-title': 'Pysäköinti',
    'about-us.sustainability-title': 'Kestävä kehitys',
    'about-us.contact-us-title': 'Ota yhteyttä',
    'about-us.opening-hours-exceptional': 'Poikkeavat aukioloajat',

    // For campaign pages:
    'offers.allDays': 'Kaikki päivät',
    'offers.allCategories': 'Kaikki toimialat',
    'offers.allOffers': 'Kaikki tarjoukset',
    'offers.showWishList': 'Näytä muistilista',
    'offers.closeOffer': 'Sulje',
    'offers.seeWholeOffer': 'Avaa koko tarjous',
    'offers.noOffers': 'Etuja ei valitettavasti tällä hetkellä ole saatavilla',
    'offers.openInfo':'Avaa lisätiedot',
    'offers.daysLowestPrice': '30 pv alin hinta',
    'offers.send-email': 'Lähetä sähköposti',

    'news-and-events.news-and-events': 'Uutiset ja tapahtumat',
    'lunch-list.modal-title': 'Lunch List',
    
    'offer-lists.search-filter-store-name': 'Liikkeet',
    'offer-lists.valid-from': 'Voimassa',

    'news-and-events-lists.search-filter-keyword': 'Avainsana',

    'news-and-events-single-article.read.more': 'Lue lisää uutisia ja tapahtumia',

    'news-letter-lift.email-address': 'Kirjoita sähköpostiosoitteesi tähän',
    'news-letter-lift.subscribe': 'Tilaa uutiskirje',
    'news-letter-lift.confirmation-message': 'Olet onnistuneesti tilannut uutiskirjeen!',

    'feedback.required_fields_marked_by_star': 'Pakolliset tiedot on merkitty tähdellä',
    'feedback.target': 'Kohde',
    'feedback.choose_shop' : 'Valitse liike',
    'feedback.type_of_feedback' : 'Palautteen tyyppi',
    'feedback.message': 'Palaute',
    'feedback.name' : 'Nimesi',
    'feedback.email' : 'Sähköpostiosoitteesi',
    'feedback.target.general': 'Haluan antaa yleistä palautetta',
    'feedback.target.store': 'Haluan antaa palautetta tietylle toimijalle',
    'feedback.type.thanks': 'Kiitos',
    'feedback.type.suggestion': 'Ehdotus',
    'feedback.type.complaint': 'Moite',
    'feedback.type.other': 'Muu',
    'feedback.rsvp' : 'Haluan, että minulle vastataan',
    'feedback.privacy_statement' : 'Rekisteriseloste',
    'feedback.thank_you' : 'Kiitos palautteesta!',
    'feedback.send': 'Lähetä',
    'feedback.error.check_all_required_fields': 'Tarkista, että kaikki pakolliset kentät on täytetty.',
    'feedback.error.field_required' : 'Kenttä on pakollinen',
    'feedback.error.invalid_email_address' : 'Osoite on virheellinen',
    'feedback.error.please_choose_a_store' : 'Valitse liike',
  }
} as Localizations;

const provider: LocalizationsProvider = {
  namespace: theme_ns,
  localizations: translations,
};

export default provider;
